//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import // XButton,
// XInput,
"vux";
import { mapState } from "vuex";

import { service, nativeApi } from "@/common/index";
import { fetch } from "@/page/index";
import moment from "moment";

export default {
  data() {
    return {
      startMonth: moment().startOf("month").toDate(), //开始月份
      endMonth: moment().startOf("month").toDate(),   //结束月份

      /** picker 相关 */
      showStartPicker: false,
      showEndPicker: false,
      startPickMonth: "",   //开始月份 *选中
      endPickMonth: "",     //结束月份 *选中
      minDate: moment().subtract(1, "year").startOf("year").toDate(),   //开始 可选择最小月份
      maxDate: moment().endOf("month").toDate(),                        //结束 可选择最大月份
      pageIndex:1,
      pageRows: 10,
      rowCount: 0,
      performances: [], //绩效数据
      isLoading: true,
      listFinished: false,
      listLoading: false,
      /** 刷新用变量 */
      refreshing: true,
    };
  },
  components: {},
  filters: {
    dateParse(val) {
      return moment(val).format("YYYY-MM");
    },
    comprehensiveDate(start, end) {
      return `${start}~${end}`;
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
    // startMonthStr: {
    //   get() {
    //     return moment(this.startMonth).format("YYYY-MM");
    //   },
    //   set(val) {},
    // },
    // endMonthStr: {
    //   get() {
    //     return moment(this.endMonth).format("YYYY-MM");
    //   },
    //   set(val) {},
    // },
  },
  created() {
    this.requestPerformance();
  },
  activated: function () {},
  methods: {
    listOnLoad() {
      this.requestPerformance()
    },
    onRefresh () {
      // 状态设置
      if (this.listFinished) {
        this.isLoading = false
        return
      }
      this.listFinished = false
      this.listLoading = true
      this.isLoading = true
      this.requestPerformance()
    },
    requestPerformance() {
      this.refreshing = true
      const _setData = (data) => {
        this.performances = [
          ...this.performances,
          ...data
        ]
      }
      fetch
        .srmSpePerformanceGde_listByPage({
          pageIndex: this.pageIndex,
          pageRows: this.pageRows,
          supplierId: this.userInfo.supplierId,
          startDate: moment(this.startMonth)
            .startOf("month")
            .format("YYYY-MM-DD"),
          endDate: moment(this.endMonth).endOf("month").format("YYYY-MM-DD"),
        })
        .then((res) => {
          console.log(res);
          if (res.status === "S") {
            if (res.code === "S") {
              if (!!res.data && res.data.length > 0) {
                if (res.page.curIndex !== res.page.nextIndex) {
                  this.pageIndex = res.page.nextIndex
                }
                this.rowCount = res.page.curIndex
                // 判断当前数据总数与后台数据总数是否相同来判断是否已添加上最后一页数据
                if (res.page.curIndex === res.page.pagesCount) {
                  this.listFinished = true
                }
                let item = res.data;
                item.forEach((item)=>{
                  // startMonth: moment().startOf("month").toDate(), //开始月份
                  //   endMonth: moment().startOf("month").toDate(),   //结束月份
                  item.startMonth = moment(this.startMonth).startOf("month").format("YYYY-MM-DD")
                  item.endMonth = moment(this.endMonth).endOf("month").format("YYYY-MM-DD")
                })
                _setData(item)
              } else {
                this.listFinished = true
              }
              this.listLoading = false
              this.isLoading = false
            }
          }
          this.refreshing = false;
        });
    },
    //格式化月份
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
    /**
     * 月份 开始、结束选择 相关 start
     */
    onClickStart() {
      this.startPickMonth = this.startMonth;
      this.showStartPicker = true;
    },
    onConfirmStart(val) {
      this.showStartPicker = false;
      this.startMonth = val;
    },
    onClickEnd() {
      this.endPickMonth = this.endMonth;
      this.showEndPicker = true;
    },
    onConfirmEnd(val) {
      this.showEndPicker = false;
      this.endMonth = val;
    },
    /**
     * 月份 开始、结束选择 相关 end
     */
   /* onRefresh() {
      this.requestPerformance();
    }*/
  },
  watch: {
    //监听开始结束时间变化，重新获取绩效数据
    startMonth(val) {
      this.requestPerformance();
    },
    endMonth(val) {
      this.requestPerformance();
    },
  },
  mounted() {
    this.pageIndex = 1
    this.performances = []
    this.requestPerformance()
  },
};



// WEBPACK FOOTER //
// ./src/page/srm/demo/performance.vue